export const unit = {
  'Are you sure you want to continue?': 'Tem certeza que deseja continuar?',
  Attention: 'Atenção',
  Cancel: 'Cancelar',
  Continue: 'Continuar',
  'If you proceed, those areas will be removed from the schedule':
    'Ao continuar, estas áreas serão removidas da agenda.',
  'I understand, continue': 'Entendi, continuar',
  "Let's schedule?": 'Vamos agendar?',
  'New clinic': 'Nova clínica',
  'Other clinic': 'Outra clínica',
  'Schedule at your last clinic or choose another one of your preference':
    'Agende em sua última clínica ou escolha outra de sua preferência.',
  Reschedule: 'Reagendar',
  'Select areas': 'Selecionar áreas',
  'Select schedule': 'Selecionar horário',
  'Select unit': 'Selecionar unidade',
  'The areas above are exclusive to another unit, and cannot be scheduled at {{unit}}':
    'As áreas acima são exclusivas de outra unidade, e não podem ser agendadas em {{unit}}.',
};
